import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import StudiosUebersicht from "../views/StudiosUebersicht.vue";
import Touch from "../views/Touch.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { onlyChef: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { pageTitle: "Anmeldung", isLoginRoute: true, isLoginResponse: false },
  },
  {
    path: "/code-response",
    name: "Login-Code-Response",
    component: Login,
    meta: { pageTitle: "Anmeldung", isLoginRoute: true, isLoginResponse: true },
  },
  {
    path: "/logout",
    name: "Lougout",
    component: Login,
    meta: { pageTitle: "Anmeldung", isLoginRoute: true, isLogoutScreen: true },
  },
  {
    path: "/touch",
    name: "Touch",
    component: Touch,
  },
  {
    path: "/tagesabschluss",
    name: "Tagesabschluss",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Tagesabschluss.vue"),
    meta: { benoetigteRechte: ["Buchhaltung/Tageseinnahmen"], },
  },
  {
    path: "/tagesabschluss/:datum",
    name: "Tagesabschluss-mit-Datum",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Tagesabschluss.vue"),
    meta: { pageTitle: "Tagesabschluss", benoetigteRechte: ["Buchhaltung/Tageseinnahmen"], },
  },
  {
    path: "/tagesabschluss/:datum/:studio",
    name: "Tagesabschluss-mit-Datum-und-Studio",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Tagesabschluss.vue"),
    meta: { pageTitle: "Tagesabschluss", benoetigteRechte: ["Buchhaltung/Tageseinnahmen"], },
  },
  {
    path: "/kassenbuch",
    name: "Kassenbuch",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Kassenbuch.vue"),
    meta: { pageTitle: "Kassenbuch", benoetigteRechte: ["Buchhaltung/Monatsabschluss"], },
  },
  {
    path: "/kassenbuch/:datum",
    name: "Kassenbuch-mit-Datum",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Kassenbuch.vue"),
    meta: { pageTitle: "Kassenbuch", benoetigteRechte: ["Buchhaltung/Monatsabschluss"], },
  },
  {
    path: "/monatsabschluss",
    name: "Monatsabschluss",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Monatsabschluss.vue"),
    meta: { pageTitle: "Monatsabschluss", benoetigteRechte: ["Buchhaltung/Monatsabschluss"], },
  },
  {
    path: "/monatsabschluss/:studio",
    name: "Monatsabschluss-mit-Studio",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Monatsabschluss.vue"),
    meta: { pageTitle: "Monatsabschluss", benoetigteRechte: ["Buchhaltung/Monatsabschluss"], },
  },
  {
    path: "/monatsabschluss/:studio/:datum",
    name: "Monatsabschluss-mit-Studio-und-Datum",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Monatsabschluss.vue"),
    meta: { pageTitle: "Monatsabschluss", benoetigteRechte: ["Buchhaltung/Monatsabschluss"], },
  },
  {
    path: "/uebersicht-studios",
    name: "Monatsuebersicht",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Monatsuebersicht.vue"),
    meta: { pageTitle: "Monatsabschluss", benoetigteRechte: ["Buchhaltung/Monatsabschluss"], },
  },
  {
    path: "/uebersicht-studios/:monat",
    name: "Monatsuebersicht-mit-Datum",
    component: () =>
      import(/* webpackChunkName: "buchhaltung" */ "../views/Monatsuebersicht.vue"),
    meta: { pageTitle: "Monatsabschluss", benoetigteRechte: ["Buchhaltung/Monatsabschluss"], },
  },
  {
    path: "/studios-uebersicht",
    name: "StudiosUebersicht",
    component: StudiosUebersicht,
    meta: { pageTitle: "Studios", },
  },
  {
    path: "/termine/:studio",
    name: "StudioTerminplan",
    component: () =>
      import(/* webpackChunkName: "planung" */ "../views/StudioTerminplan.vue"),
    //component: StudioTerminplan, // () => import("../views/StudioTerminplan.vue"),
  },
  {
    path: "/termine/:studio/:datum",
    name: "StudioTerminplan-mit-Datum",
    component: () =>
      import(/* webpackChunkName: "planung" */ "../views/StudioTerminplan.vue"),
    //component: StudioTerminplan, // () => import("../views/StudioTerminplan.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/Dashboard.vue"),
  },
  {
    path: "/fullscreen",
    name: "Fullscreen",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../components/FullscreenDemo.vue"
      ),
  },
  {
    path: "/dienstplan",
    name: "Dienstplan",
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/Dienstplan.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/sample",
    name: "sample",
    component: () => import(/* webpackChunkName: "demo" */ "../components/SampleDemo.vue"),
  },
  {
    path: "/forms",
    name: "forms",
    component: () => import(/* webpackChunkName: "demo" */ "../components/FormsDemo.vue"),
  },
  {
    path: "/data",
    name: "data",
    component: () => import(/* webpackChunkName: "demo" */ "../components/DataDemo.vue"),
  },
  {
    path: "/panels",
    name: "panels",
    component: () => import(/* webpackChunkName: "demo" */ "../components/PanelsDemo.vue"),
  },
  {
    path: "/overlays",
    name: "overlays",
    component: () => import(/* webpackChunkName: "demo" */ "../components/OverlaysDemo.vue"),
  },
  {
    path: "/menus",
    component: () => import(/* webpackChunkName: "demo" */ "../components/MenusDemo.vue"),
    children: [
      {
        path: "",
        component: () => import(/* webpackChunkName: "demo" */ "../components/menu/PersonalDemo.vue"),
      },
      {
        path: "/menus/seat",
        component: () => import(/* webpackChunkName: "demo" */ "../components/menu/SeatDemo.vue"),
      },
      {
        path: "/menus/payment",
        component: () => import(/* webpackChunkName: "demo" */ "../components/menu/PaymentDemo.vue"),
      },
      {
        path: "/menus/confirmation",
        component: () => import(/* webpackChunkName: "demo" */ "../components/menu/ConfirmationDemo.vue"),
      },
    ],
  },
  {
    path: "/messages",
    name: "messages",
    component: () => import(/* webpackChunkName: "demo" */ "../components/MessagesDemo.vue"),
  },
  {
    path: "/charts",
    name: "charts",
    component: () => import(/* webpackChunkName: "demo" */ "../components/ChartsDemo.vue"),
  },
  {
    path: "/misc",
    name: "misc",
    component: () => import(/* webpackChunkName: "demo" */ "../components/MiscDemo.vue"),
  },
  {
    path: "/empty",
    name: "empty",
    component: () => import(/* webpackChunkName: "demo" */ "../components/EmptyPage.vue"),
  },
  /*
		{
			path: '/documentation',
			name: 'documentation',
			component: () => import('./components/Documentation.vue')
		},
		*/
];

const router = new VueRouter({
  mode: "history", // oder 'hash'
  base: process.env.BASE_URL,
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  /*
  if (!router.app.$znaApi.isValidLogin()) {

  }
  */
  //if (localStorage.getItem('registered'))
  function redirectToLogin(reason: string) {
    const origRequestData = JSON.stringify({
      path: to.path,
      params: to.params,
      query: to.query,
    });
    const redirectParams = { reason, origRequestData };
    next({ name: "Login", params: redirectParams });
  }
  if (to.matched.some((record) => record.meta?.onlyZentrale)) {
    /*
    if (!router.app.$znaApi.isZentrale()) {
      return redirectToLogin('nicht Zentrale');
    }
    */
  }
  if (to.matched.some((record) => record.meta?.onlyStudio)) {
    /*
    if (!router.app.$znaApi.isStudio()) {
      return redirectToLogin('nicht Studio');
    }
    */
  }
  if (to.matched.some((record) => record.meta?.onlyChef)) {
    /*
    if (!router.app.$znaApi.isStudio()) {
      return redirectToLogin('nicht Admin');
    }
    */
  }
  to.matched.forEach((record) => {
    document.title = record.meta?.pageTitle || record.name || "zna-admin";
  });
  next();
});

export default router;
